import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCreditAndCollections extends Layout {
    checkboxCollectionsOk: Checkbox;
    checkboxCreditApplication: Checkbox;
    horizontalspacer10: HorizontalSpacer;
    horizontalspacer11: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    horizontalspacer9: HorizontalSpacer;
    labelAvailCredit: Label;
    labelAvailableCredit: Label;
    labelBalance: Label;
    labelBalanceValue: Label;
    labelCashReceipts: Label;
    labelCashReceiptsValue: Label;
    labelCollectionInformation: Label;
    labelCreditInformation: Label;
    labelMiscBilled: Label;
    labelMiscBills: Label;
    labelNotRated: Label;
    labelNotRatedValue: Label;
    labelO: Label;
    labelUnbilled: Label;
    labelUnbilledValue: Label;
    panelAvailCredit: Panel;
    panelBalance: Panel;
    panelCashReceipts: Panel;
    panelCreditCalculations: Panel;
    panelCreditCollections: Panel;
    panelMiscBill: Panel;
    panelNotRated: Panel;
    panelSpacer: Panel;
    panelUnbilled: Panel;
    sourceCreditCalculations: DataSource;
    sourceCustomer: DataSource;
    textboxCollThreshPd1: Textbox;
    textboxCollThreshPd2: Textbox;
    textboxCollThreshPd3: Textbox;
    textboxCollThreshPd4: Textbox;
    textboxCollectionsId: Textbox;
    textboxCreditCheckDate: Textbox;
    textboxCreditLimitN: Textbox;
    textboxCreditStatus: Textbox;
    textboxCreditWarningPct: Textbox;
    textboxDAndBCode: Textbox;
    textboxDAndBDate: Textbox;
    textboxDAndBNumber: Textbox;
    textboxNxtActionCodeId: Textbox;
    textboxNxtActionDate: Textbox;
}
